import React, { useState, useEffect } from "react";
import "./ServicesSection.css";

const services = [
  "Airline Ticketing",
  "Hotel Tie-Ups",
  "Budget-Friendly",
  "Personalized Planning",
  "Staycations & Workations",
  "Inbound & Outbound Tours",
  "Visa Assistance",
  "Forex",
  "Adventure Tours",
  "Family & Honeymoon Tours",
];

const serviceImages = {
  "Airline Ticketing": "/Services/airplane.jpg",
  "Hotel Tie-Ups": "/Services/hotel.jpg",
  "Budget-Friendly": "/Services/wallet.jpg",
  "Personalized Planning": "/Services/planning.jpg",
  "Staycations & Workations": "/Services/laptop-beach.jpg",
  "Inbound & Outbound Tours": "/Services/globe-tour.jpg",
  "Visa Assistance": "/Services/passport.jpg",
  "Forex": "/Services/currency-exchange.jpg",
  "Adventure Tours": "/Services/mountain-climb.jpg",
  "Family & Honeymoon Tours": "/Services/family-couple.jpg",
};

function ServicesSection() {
  const [hoveredService, setHoveredService] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleHover = (service) => {
    if (!isMobile) setHoveredService(service);
  };

  const getClassName = (service) =>
    `grid-${service.toLowerCase().replace(/\s+&\s+/g, " and ").replace(/\s+/g, "-")}-hover`;

  return (
    <section className="services-page">
      <div className={`services-grid ${!isMobile && hoveredService ? getClassName(hoveredService) : ""}`}>
        {services.map((service, index) => (
          <div
            key={index}
            className={`service-box ${hoveredService === service ? "hovered" : ""}`}
            onMouseEnter={() => !isMobile && handleHover(service)}
            onMouseLeave={() => !isMobile && setHoveredService(null)}
            style={
              isMobile
                ? {
                    backgroundImage: `url(${serviceImages[service]})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    color: "#fff",
                    backgroundBlendMode: "overlay",
                  }
                : hoveredService === service
                ? {
                    backgroundImage: `url(${serviceImages[service]})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    color: "#fff",
                    backgroundBlendMode: "overlay",
                  }
                : {}
            }
          >
            <span>{service}</span>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ServicesSection;
